import React from 'react';
import { useViewlogies } from 'context';
import { FormattedMessage } from 'react-intl';
import VideoInterface from '../VideoInterface';
import './griefResource.scss';
import copingResourcesImg from 'assets/grief.jpg';

const GriefResource = () => {
    const {
        event: { griefSupportUrl, griefSupportVideoUrl, firstName, lastName, color, isLoggedIn },
    } = useViewlogies();

    // if (!isLoggedIn) {
    //     return null;
    // }
    const videoUrl = griefSupportVideoUrl || 'https://vimeo.com/1109822054';

    const copingResources = (
        <VideoInterface
            videoUrl={videoUrl}
            color={color}
            title={
                <FormattedMessage
                    id="features.Viewlogy.Resources.copingResources"
                    defaultMessage="Find Hope And Heal"
                />
            }
            description={
                <FormattedMessage
                    id="features.Viewlogy.Resources.copingDescription"
                    defaultMessage="We are sorry for your loss of {1}. We hope you will find moments of peace with these free videos."
                    values={{ 1: `${firstName} ${lastName}` }}
                />
            }
            //if griefSupportUrl is not set, use brightermornings.com
            link={griefSupportUrl ? griefSupportUrl : 'https://brightermornings.com/find-hope-and-heal'}
            linkText={
                <FormattedMessage id="features.Viewlogy.Resources.copingLink" defaultMessage="Get grief support" />
            }
        />
    );

    return (
        <>
            <div className="grief-resource">{copingResources}</div>
        </>
    );
};

export default GriefResource;
